import { type StatusData } from '../Layers/Layers.types';
import { TrafikenConfig } from '../TrafikenConfig';
import { AjaxSource } from './AjaxSource';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions = (region) => ({
    id: 'travel-time-status-source',
    url: `${TrafikenConfig.infoLayerServiceBaseUrl}/api/traveltime?region=${region}`,
    displayName: 'Trafikflöde',
});

export interface TravelTimeStatus extends StatusData {
    name: string;
    status?: string;
    speed?: number;
    measureTime?: string;
}

export class TravelTimeStatusSource extends AjaxSource {
    constructor(region: string, options?: Partial<AjaxSourceOptions>) {
        super({ ...defaultOptions(region), ...options });
    }
}
